import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import axios from "axios";
import { useStyles } from "../Pages/BookOrder/BookOrderStyle";
import { ContractContext } from "../Context/ContractContext";
import { useSelector } from "react-redux";
 

const DiscountBox = ({ hide }) => {
  const { setDiscountValue, discountValue,code, setCode, setDiscountType, setDiscount,setCheckOut } = useContext(ContractContext);
  const classes = useStyles();
  const { data: result } = useSelector((state) => state.cart);
  const inputRef = useRef(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isApplying, setIsApplying] = useState(false);

  const handleApplyDiscount = async () => {
    setCheckOut(false)
    setError("");
    setMessage("");
    if (!code.trim()) {
      setError("");
       setDiscountValue(0);
      setDiscountType(null);
      setDiscount(0);
      return;
    }

    try {
      setIsApplying(true);
      const res = await axios.get(
        `${
          process.env.REACT_APP_API
        }/apply/discount?code=${code}&cart_id=${localStorage.getItem("user")}&affiliate=${localStorage.getItem("referer")}`
      );
      // console.log(res.data);

      setDiscountValue(res.data.discountValue);
      setDiscountType(res.data.discountType);
      setDiscount(res.data.discount);

      // setMessage(`Discount applied: $${`${res.data.discountValue} off`}`);
    } catch (err) {
      // setError(
      //   err?.response?.data?.message || "Invalid or expired discount code."
      // );
    } finally {
      setIsApplying(false);
    }
  };

  return (
    <Box>
      {/* <Typography
        sx={{
          fontSize: { sm: "18px", xs: "18px" },
          fontFamily: "ABLE",
          lineHeight: "35px",
          fontWeight: "600",
          pb: "0.2rem",
          color: "rgb(109 79 160)",
        }}
      >
        dc
      </Typography> */}

      {/* <Box
        sx={{
          border: "1px solid rgb(109 79 160)",
          p: hide ? "0.5rem 1rem" : "1rem",
          mb: "1rem",
        }}
      > */}
        <Box
          sx={{
            display: "flex",
            gap: "10px",
          }}
        >
          <Typography style={{cursor: "pointer", fontStyle: "italic"}} onClick={() => inputRef.current.focus()}>
          dc
          </Typography>
          <input
          type="text" 
            fullWidth  
            placeholder=""
            id="code"
            name="code"
            ref={inputRef}
            value={code}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleApplyDiscount();
              }
            }}
            onBlur={handleApplyDiscount}
            onChange={(e) => setCode(e.target.value)}
            style={{ height: "24px", padding: "5px" , width: "65px" , border: "none" }}
            // className={classes.bin1}
          />

          {/* <Button
            type="button"
            className={classes.proceed_btn}
            sx={{ width: "130px", minHeight: "auto" }}
            onClick={handleApplyDiscount}
            disabled={isApplying}
          >
            {isApplying && (
              <CircularProgress
                sx={{
                  width: "12px !important",
                  height: "12px !important",
                  color: "#e4dbe7",
                  mr: "0.5rem",
                }}
              />
            )}
            Apply
          </Button> */}
          {discountValue > 0 && (
            <Button
              type="button" 
              sx={{ width: "auto",padding: 0, fontSize:"14px", minHeight: "auto" }}
              onClick={() => {
                setDiscountValue(0);
                setMessage("");
                setCode("")
                setDiscountType("")
                setDiscount("")
                setCheckOut(false)
              }}
            >
              Remove
            </Button>
          )}
        </Box>

        {message && (
          <Typography
            color="success.main"
            textAlign="center"
            mt={2}
            fontSize={14}
          >
            {message}
          </Typography>
        )}
        {error && (
          <Typography color="error" textAlign="center" mt={2} fontSize={14}>
            {error}
          </Typography>
        )}
      </Box>
    // </Box>
  );
};

export default DiscountBox;
